module.exports = {
    'Init': require('./init'),
    'SetupForm': function() {
        console.log('Legacy SetupForm called');
    }
};